import React from 'react';
import { ChildrenPropType } from '../../../../prop-types/children';
import PropTypes from 'prop-types';

import style from './order-summary.module.less';
import classNames from 'classnames';

const LabeledField = ({ children, label, classname = '' }) => {
  return (
    <div className={classNames(style['labeled-field'], classname)}>
      <label className={style.label}>{label}</label>
      <div>{children}</div>
    </div>
  );
};

LabeledField.propTypes = {
  children: ChildrenPropType.isRequired,
  label: PropTypes.node.isRequired,
  classname: PropTypes.string,
};

export default LabeledField;
